

















import { Component, Model, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { CompanySetting } from '@/models/companySetting';
import type { Project } from '@/models/project';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';

@Component({
    name: 'ColumnsFilter',
    components: {},
})
export default class ColumnsFilter extends Vue {
    @Model('change', {
        required: true,
    })
    private tableColumns: AppliedLessonsFilter;

    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('project/selectedProject') private selectedProject: Project;

    mounted() {
        this.initColumns();
    }

    private initColumns() {
        if (this.companySetting.feature_dynamic_worksheet_field) {
            this.columns.dynamic_field.visible = true;
            this.columns.dynamic_field.title = this.companySetting.dynamic_worksheet_field_name;
        }

        if (this.selectedProject && this.selectedProject.ms_integration) {
            this.columns.solution.display_default = true;
            this.columns.contacttill.display_default = true;
            this.columns.responsible.display_default = true;
        }

        if (this.companySetting.feature_dynamic_worksheet_field_impact) {
            this.columns.impact.visible = true;
        }

        this.setColumnsToDefaultDisplay();
    }

    private toggleAllColumns() {
        const setToState = !this.allColumnsSelected;

        for (const [key] of Object.entries(this.columns)) {
            if (this.columns[key].visible) {
                this.columns[key].display = setToState;
            }
        }
    }

    private setColumnsToDefaultDisplay() {
        for (const [key] of Object.entries(this.columns)) {
            this.columns[key].display = this.columns[key].display_default;
        }
    }

    get allColumnsSelected() {
        return Object.keys(this.columns).every((key) => {
            // Only consider the display status if the column is visible
            return !this.columns[key].visible || this.columns[key].display;
        });
    }

    get columns() {
        return this.tableColumns;
    }

    set columns(value) {
        this.$emit('change', value);
    }
}
